import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

export type InactivityWarningDialogResult = 'stay' | 'logout';

@Component({
  selector: 'app-inactivity-warning-dialog',
  standalone: true,
  imports: [MatDialogModule],
  template: `
    <div
      class="bh-session-expiry-dialog-inner px-6 pt-5 pb-5 bg-white dark:bg-gray-800 text-center">
      <div class="flex justify-center mb-3" aria-hidden="true">
        <div
          class="flex h-12 w-12 items-center justify-center rounded-full bg-warning/20">
          <svg
            class="h-6 w-6 text-warning"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
      </div>
      <h2 class="text-lg font-semibold text-[#4D4D4D] dark:text-gray-200">
        Session Timeout Warning
      </h2>
      <p
        class="mt-2 text-sm leading-relaxed text-[#4D4D4D] dark:text-gray-300 px-1">
        You will be logged out due to inactivity in 5 minutes. Click "Stay Logged
        In" to continue your session.
      </p>
      <div class="mt-6 flex flex-row justify-center gap-4">
        <button
          type="button"
          [mat-dialog-close]="'logout'"
          class="min-w-[96px] rounded-full border border-gray-400 bg-white px-3 py-2 text-[13px] font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-500 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700">
          Logout Now
        </button>
        <button
          type="button"
          [mat-dialog-close]="'stay'"
          class="min-w-[96px] rounded-full bg-primary px-3 py-2 text-[13px] font-medium text-white transition-opacity hover:opacity-90">
          Stay Logged In
        </button>
      </div>
    </div>
  `,
})
export class InactivityWarningDialogComponent {}
